import { FontTypeEnum } from '../enums/FontTypeEnum';
import { ProductTypeEnum } from '../enums/ProductTypeEnum';
import { IntermediaryFeePeriodEnum } from '../enums/IntermediaryFeePeriodEnum';

export class ConfigSettingDto {
  iframeHeight: number;
  iframeWidth: number;
  fontSizeParagraph: number;
  fontSizeH1: number;
  fontSizeH2: number;
  fontType: FontTypeEnum;
  fontColor: string;
  backgroundTextColor: string;
  backgroundColor: string;
  inputColor: string;
  inputBorderColor: string;
  closingText: string;
  intermediaryEmail: string;
  intermediaryName: string;
  intermediaryPhone: string;
  intermediaryId: string;
  intermediaryFee?: string;
  intermediaryFeePeriod?: IntermediaryFeePeriodEnum;
  url: string;
  productType: ProductTypeEnum;
  showIntermediaryFee: boolean;
  intermediarySubscriptionFeeText?: string;
  showIntermediarySubscriptionFee: boolean;
  intermediarySubscriptionFeePeriod?: IntermediaryFeePeriodEnum;
  intermediarySubscriptionFee?: string;
  finalStatementAddition?: string;
}
